module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-panel weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-panel-container', !_vm.hasBottomBar && 'container-bottom-padding'],
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.matrixData), function(line, index) {
    return _c('div', {
      key: index,
      staticClass: "dashboard weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, _vm._l((line), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: " weex-ct weex-div",
        class: ['cell', !_vm.hasBottomBar && 'cell-no-Btn-Bar'],
        style: ([_vm._px2rem(_vm.adaptBorderFn(index, _vm.matrixData.length - 1, i, line.length - 1), 75), _vm._px2rem(_vm.adaptPaddingFn(index, _vm.matrixData.length - 1, i, line.length - 1), 75)]),
        attrs: {
          "weex-type": "div"
        }
      }, [_c('div', {
        staticClass: "title weex-ct weex-div",
        attrs: {
          "weex-type": "div"
        }
      }, [_c('p', {
        staticClass: "title-text weex-el weex-text",
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
        staticClass: "value weex-ct weex-div",
        attrs: {
          "weex-type": "div"
        }
      }, [_c('p', {
        staticClass: "value-text weex-el weex-text",
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('p', {
        staticClass: "unit-text weex-el weex-text",
        attrs: {
          "weex-type": "text"
        }
      }, [_vm._v(_vm._s(item.unit))])])])
    }), 0)
  }), 0), _vm._v(" "), (_vm.hasBottomBar) ? _c('div', {
    staticClass: "btn weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClicked($event)
      }
    }
  }, [_c('p', {
    staticClass: "btn-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d2670bf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2670bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-panel/index.vue
// module id = 633
// module chunks = 0 1